const daysOfWeek = [
  { short: "Пн", long: "Понедельник" },
  { short: "Вт", long: "Вторник" },
  { short: "Ср", long: "Среда" },
  { short: "Чт", long: "Четверг" },
  { short: "Пт", long: "Пятница" },
  { short: "Сб", long: "Суббота" },
  { short: "Вс", long: "Воскресенье" },
];

export default {
  daysOfWeek: daysOfWeek,
  photoFormats: ["jpg", "png", "jpeg", "gif"],
};
